





















































































import {
  computed,
  defineComponent,
  PropType,
  ref
} from '~/utils/nuxt3-migration'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCardTitle from '~/components/shared/configurable/card/CCardTitle.vue'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import TbiCalculator from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiCalculator.vue'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import { useAnalytics } from '~/compositions/analytics'
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { OnlineLoanType, SantanderLoanInfo } from '~/constants/loan/loans'
import SantanderCalculator from '~/components/car/classifieds/view/partials/loans/calculator/santander/SantanderCalculator.vue'
import AlphaCalculator from '~/components/car/classifieds/view/partials/loans/calculator/alpha/AlphaCalculator.vue'
import TbiInfoModal from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiInfoModal.vue'

export default defineComponent({
  components: {
    TbiInfoModal,
    AlphaCalculator,
    SantanderCalculator,
    LoanPerks,
    TbiCalculator,
    CImg,
    CCardTitle,
    CCard,
    CCardHeader
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    })
  },
  props: {
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: OnlineLoanType.AUTO
    },
    extraLoanInfo: {
      type: Object as PropType<SantanderLoanInfo>,
      required: true
    }
  },
  setup(props) {
    const analytics = useAnalytics()
    const randomId = uuidv4()

    const tbiExpanded = ref(false)
    const alphaExpanded = ref(false)
    const showTbiInfoModal = ref(false)
    const onVisible = () => {
      analytics.recordEvent({
        namespace: 'n_classified_view_loans_visible',
        action: 'load',
        label: randomId
      })
    }

    const isTbi = computed(() =>
      [OnlineLoanType.AUTO, OnlineLoanType.CONSUMER].includes(props.loanType)
    )

    const handleExpand = (bank: string, expanded: boolean) => {
      if (expanded) {
        if (bank === 'tbi') {
          alphaExpanded.value = false
        } else if (bank === 'alpha') {
          tbiExpanded.value = false
        }
      }
    }

    const showTbiLogo = computed(() => {
      return isTbi.value && !props.extraLoanInfo.showAlpha
    })

    return {
      randomId,
      onVisible,
      isTbi,
      OnlineLoanType,
      tbiExpanded,
      alphaExpanded,
      handleExpand,
      showTbiInfoModal,
      showTbiLogo
    }
  }
})
